import React, { useState } from 'react';
import Text from '../Text/index';
import { joinClasses } from '../../../../Utils/className.util';
import InfoTooltip from '../Popup/InfoTooltip';
import styles from './Label.module.scss';

interface ILabel {
	tx: string;
	isOptional?: boolean;
	firstUpper?: boolean;
	className?: any;
	style?: any;
	isMaxContentWidth?: boolean;
	tooltip?: string;
}

export default function Label(props: ILabel) {
	const {
		tx,
		isOptional = false,
		firstUpper = false,
		isMaxContentWidth = false,
		className,
		style,
		tooltip,
	} = props;

	return tx ? (
		<div className={joinClasses([styles.wrapper, className])}>
			<Text
				className={joinClasses([
					styles.title,
					isMaxContentWidth ? styles.maxContent : undefined,
				])}
				tx={tx}
				firstUpper={firstUpper}
				style={style}
			/>
			{tooltip && (
				<InfoTooltip>
					<Text tx={tooltip} />
				</InfoTooltip>
			)}
			{isOptional && (
				<Text className={styles.optional} tx={'base.notRequired'} />
			)}
		</div>
	) : null;
}
